// Core
import React from 'react';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, notification, Popconfirm } from 'antd';

// App
import {
  pacienteDeleteAction,
  pacienteListAction
} from '../../../redux/clinica/pacientes/actionCreator';

const PacienteView = ({ registro }) => {
  const dispatch = useDispatch();
  const { id, nombre, paterno, materno, telefono_movil, sucursal, folio, folio_historico, tipo_origen } = registro;
  const nombrePaciente = nombre.toUpperCase() + ' ' + paterno.toUpperCase() + ' ' + materno.toUpperCase();

  const eliminar = async id => {
    let values = { id };
    const responseApi = await dispatch(pacienteDeleteAction(values));
    if (responseApi) {
      let mensaje = 'Paciente eliminado exitosamente';
      notification.success({
        message: mensaje,
      });
      dispatch(pacienteListAction());
    } else {
      notification.error({
        message: 'Error al procesar paciente',
      });
    }
  };

  const noEliminar = e => {
    console.log(e);
  };


  return (
    <Card size="small" title={<span style={{ fontSize: '14px', color: 'black', textAlign: 'left' }}>{nombrePaciente}</span>}>

      <p><FontAwesome name="phone" /> <small>Teléfono: {telefono_movil}</small> <br />
        <FontAwesome name="id-card" /><small> Folio: {folio_historico ? folio_historico : '---'}</small> <br />
        <FontAwesome name="link" /> <small>Origen: {tipo_origen ? tipo_origen : '---'}</small> </p>
      <p className='text-left'>
        <Popconfirm
          title="¿Eliminar éste registro?"
          onConfirm={() => eliminar(id)}
          onCancel={noEliminar}
          okText="Si"
          cancelText="No"
        >
          <span
            style={{ backgroundColor: '#F44335', padding: '6px', borderRadius: '4px', color: 'white', marginRight: '4px', paddingRight: '4px', cursor: 'pointer' }}>
            Eliminar <FontAwesome name="trash" style={{ color: 'white' }} />
          </span>
        </Popconfirm>

        <Link to={`/admin/clinica/pacientes/expediente/${id}`}>
          <span style={{ backgroundColor: '#03A9F4', padding: '6px', borderRadius: '4px', color: 'white' }}>
            Ver info <FontAwesome name="arrow-circle-right" style={{ color: 'white' }} />
          </span>
        </Link>
      </p>
    </Card>


  );
};

export default PacienteView;
